<template>
    <div class="pt-translatable-textfield">
        <v-btn-toggle tile
                      group
                      mandatory
                      v-model="language"
                      class="mb-2">
            <v-btn small  v-for="lang in languages" :key="lang" :value="lang">
                {{ lang.toUpperCase() }}
            </v-btn>
        </v-btn-toggle>
        <v-text-field :label="`${fieldTitle || ''} ${language.toUpperCase()}`"
                      outlined
                      dense
                      hide-details
                      :placeholder="`${fieldTitle || ''} ${language.toUpperCase()}`"
                      v-model="value"></v-text-field>
    </div>
</template>

<script>
export default {
    name: 'TranslatableTextField',
    data() {
        return {
            languages: ['en', 'et', 'fi', 'lt'],
            language: 'en',
            translatedProp: {}
        }
    },
    props: {
        valueProp: {
            type: Object
        },
        fieldTitle: {
            type: String,
        }
    },
    computed: {
        value: {
            get() {
                return this.translatedProp[this.language] || '';
            },
            set(newValue) {
                this.translatedProp[this.language] = newValue;

                const payload = {
                    language: this.language,
                    value: newValue
                }

                this.$emit('changeValue', payload)
            },
        }
    },
    created() {
        this.languages.forEach(l => {
            this.translatedProp[l] = null;
        })

        Object.keys(this.valueProp).forEach(k => {
            this.translatedProp[k] = this.valueProp[k]
        })
    }
};
</script>

<style scoped>

</style>